import { COLOR } from "@dmm-com/rocket-web-ui-library";
import styled from "@emotion/styled";
import type { Horizontal } from "~/components/blocks/product/common/video-legacy-season/sample-viewer-modal/desktop";
import { fadeIn } from "~/styles/animation";
import { Z_INDEX } from "~/styles/z-index";

export const DivContainer = styled.div`
  position: relative;
  width: 100%;
  height: 100vh;
  height: calc((var(--vh, 1vh) * 100) - 48px);
  animation: ${fadeIn} 0.5s ease;
`;

export const DivImageWrapper = styled.div`
  position: relative;
  display: flex;
  justify-content: center;
  flex-shrink: 0;
  height: 100%;
  width: 100%;
`;

export const ImgGravure = styled.img`
  object-fit: contain;
  position: absolute;
  width: 90%;
  height: 90%;
`;

export const DivWrapScreen = styled.div<{ horizontal: Horizontal }>`
  position: absolute;
  top: 0;
  ${({ horizontal }) => (horizontal === "toLeft" ? `left: 0;` : `right: 0;`)}
  height: 100%;
  width: 50%;
  cursor: pointer;
`;

export const ButtonIconWrapper = styled.button<{
  horizontal: Horizontal;
}>`
  position: absolute;
  top: 0;
  bottom: 0;
  ${({ horizontal }) => (horizontal === "toLeft" ? `left: 0;` : `right: 0px;`)}
  z-index: ${Z_INDEX.MODAL_IN_MODAL + 2};

  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 64px;
  margin: auto;
  border-radius: 8px;
`;

export const DivPageIndexWrapper = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  text-shadow: 1px 1px 2px ${COLOR.GRAY50.code};
  margin: auto;
  text-align: center;
`;
